import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { faEye, faEyeSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ParentCategory, Subcategory } from 'store/categoryStore';
import { observer } from 'mobx-react';

@observer
class HideButton extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        const { hidden, category } = this.props;

        if (!category.loading) {
            if (hidden) {
                // This category is hidden, we need to unhide it
                category.requestSetHidden(false);
            } else {
                // This category is visible, we need to hide it
                category.requestSetHidden(true);
            }
        }
    }

    render() {
        const { hidden, category } = this.props;
        const { loading } = category;

        return (
            <button onClick={this.handleClick} disabled={loading} type="button" className="btn btn-default">
                {loading ? (
                    <FontAwesomeIcon icon={faSpinner} pulse={true} fixedWidth={true}/>
                ) : (
                    <FontAwesomeIcon icon={hidden ? faEye : faEyeSlash} fixedWidth={true} />
                )}
            </button>
        )
    }
}

HideButton.propTypes = {
    category: PropTypes.oneOfType([
        PropTypes.instanceOf(ParentCategory),
        PropTypes.instanceOf(Subcategory),
    ]).isRequired,
    hidden: PropTypes.bool,
};

export default HideButton;



// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/hide-button.js